import React from 'react';
import { FormField, formInputClass } from '../form';

export const MONOTRIBUTO_CATEGORIAS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];

export default function BusinessFiscalFields({
  values,
  onChange,
  tc,
  extras = false,
  compact = false,
  tight = false,
}) {
  const v = values || {};
  const gridGap = tight ? 'gap-1.5 sm:gap-2' : compact ? 'gap-2 sm:gap-2.5' : 'gap-4';
  const inputCls = formInputClass(tc.inputClass, { compact });

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${gridGap}`}>
      <FormField label="Nombre de la empresa" required labelClass={tc.labelClass}>
        <input
          className={inputCls}
          value={v.companyName || ''}
          onChange={(e) => onChange('companyName', e.target.value)}
          placeholder="Nombre comercial o emprendimiento"
          required
        />
      </FormField>

      {extras && (
        <FormField label="Razón social" required labelClass={tc.labelClass}>
          <input
            className={inputCls}
            value={v.legalName || ''}
            onChange={(e) => onChange('legalName', e.target.value)}
            placeholder="Razón social legal"
            required
          />
        </FormField>
      )}

      <FormField label="CUIT" required labelClass={tc.labelClass}>
        <input
          className={inputCls}
          value={v.cuit || ''}
          onChange={(e) => onChange('cuit', e.target.value)}
          placeholder="20-12345678-9"
          inputMode="numeric"
          autoComplete="off"
          required
        />
      </FormField>

      <FormField
        label="Dirección"
        required
        className="sm:col-span-2"
        labelClass={tc.labelClass}
      >
        <input
          className={inputCls}
          value={v.address || ''}
          onChange={(e) => onChange('address', e.target.value)}
          placeholder="Calle y número"
          required
        />
      </FormField>

      <FormField label="Régimen fiscal" required labelClass={tc.labelClass}>
        <select
          className={inputCls}
          value={v.regimenFiscal || ''}
          onChange={(e) => onChange('regimenFiscal', e.target.value)}
          required
        >
          <option value="">Elegí tu régimen</option>
          <option value="monotributo">Monotributo</option>
          <option value="ri">Responsable inscripto</option>
        </select>
      </FormField>

      {v.regimenFiscal === 'monotributo' && (
        <>
          <FormField label="Categoría de Monotributo" required labelClass={tc.labelClass}>
            <select
              className={inputCls}
              value={v.categoriaMonotributo || ''}
              onChange={(e) => onChange('categoriaMonotributo', e.target.value)}
              required
            >
              <option value="">Elegí categoría</option>
              {MONOTRIBUTO_CATEGORIAS.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </FormField>
          <FormField label="Actividad" labelClass={tc.labelClass}>
            <select
              className={inputCls}
              value={v.actividad || 'servicios'}
              onChange={(e) => onChange('actividad', e.target.value)}
            >
              <option value="servicios">Servicios / locaciones</option>
              <option value="bienes">Venta de bienes</option>
            </select>
          </FormField>
        </>
      )}
    </div>
  );
}
